import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalTitle,
  ModalContent,
  ModalActions,
} from '@the-platform-group/component-library/Modal'
import { Button } from '@the-platform-group/component-library/Button'
import { Grid } from '@the-platform-group/component-library'
import ManageRequestForm from './ManageRequestForm'
import { useManageRequestForm } from '../hooks/useManageRequestForm'

/**
 * Modal component for managing request details
 * @param {object} props - component props
 * @param {boolean} props.open - whether the modal is open
 * @param {function} props.onClose - function to close the modal
 * @param {object} props.request - the request data to manage
 * @returns {React.ReactElement} The rendered ManageRequestModal component
 */
const ManageRequestModal = ({ open, onClose, request }) => {
  const { control, formState, setValue, handleSubmit, handleClose, isSubmitting } =
    useManageRequestForm(onClose, request)

  const { isValid } = formState

  // Don't render if no request is provided
  if (!request) {
    return null
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalTitle title="Manage request" />
      <ModalContent>
        <ManageRequestForm
          control={control}
          formState={formState}
          setValue={setValue}
          request={request}
        />
      </ModalContent>
      <ModalActions>
        <Grid container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button variant="text" onClick={handleClose}>
              Cancel
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={handleSubmit}
              disabled={!isValid || isSubmitting}
              isLoading={isSubmitting}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </ModalActions>
    </Modal>
  )
}

ManageRequestModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  request: PropTypes.object,
}

export default ManageRequestModal
